import {
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IBoleto } from 'src/app/interfaces';

@Component({
  selector: 'app-modal-download-boleto',
  templateUrl: './modal-download-boleto.component.html',
  styleUrls: ['./modal-download-boleto.component.scss']
})
export class ModalDownloadBoletoComponent {
  @Output() closeModal = new EventEmitter();
  @Output() confirm = new EventEmitter<IBoleto>();
  @ViewChild('ModalDownload') ModalDownload: TemplateRef<any>;
  boleto: IBoleto;

  constructor(private modalService: NgbModal) {}

  openModal(boleto: IBoleto) {
    this.modalService.open(this.ModalDownload, {
      centered: true,
      size: 'lg'
    });
    this.boleto = boleto;
  }

  fecharModal() {
    this.closeModal.emit();
  }

  doDownload() {
    this.confirm.emit(this.boleto);
    this.fecharModal();
  }
}
